import React from 'react';
import { resolveCabinetSchematic } from './CabinetFrame';
import {
  CabinetBackElevation,
  CabinetFrontElevation,
  CabinetSideElevation,
} from './CabinetElevation';

/**
 * Elevation schematic for `upper-cabinet`.
 *
 * Same drawing as `LowerCabinetSchematic` from the same `cabinetFrontLayout`,
 * with `isUpperCabinet` set: no toe kick, and door pulls near the bottom of
 * the door (within reach from standing height), exactly as
 * `cabinetRenderer.upperCabinetRenderer` places them.
 */
export function UpperCabinetSchematic({
  widthMeters: width,
  heightMeters: height,
  depthMeters: depth,
  view = 'front',
  obj = {},
  strokeColor,
  strokeWidth,
}) {
  // A valance bay is the valance's handle; the valance itself is drawn with
  // the cabinet trim (`cabinetTrimElevation`)
  if (obj.category?.valanceBay) return null;
  const { layout, doorStyle, hardwareType } = resolveCabinetSchematic(
    obj,
    { width, height, depth },
    true
  );
  const stroke = { strokeColor, strokeWidth };
  if (view === 'left' || view === 'right') {
    return (
      <CabinetSideElevation
        layout={layout}
        view={view}
        hardwareType={hardwareType}
        {...stroke}
      />
    );
  }
  if (view === 'back') {
    return <CabinetBackElevation layout={layout} {...stroke} />;
  }
  return (
    <CabinetFrontElevation
      layout={layout}
      doorStyle={doorStyle}
      hardwareType={hardwareType}
      {...stroke}
    />
  );
}

UpperCabinetSchematic.supportsSideViews = true;
// A run's back is a finished panel — `CabinetBackElevation` draws it.
UpperCabinetSchematic.supportsBackView = true;
